/** @jsxImportSource @emotion/react */

import { Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { validateRequired } from 'utils/validation'
import { SelectField } from 'components/Select'
import { PlatformSlug } from 'constants/consts'
import { colors } from 'theme/colors'

import { StudyGuideIconEnum } from '__generatedTypes__/globalTypes'
import * as classes from './styles'

import { ReactComponent as BookIcon } from './icons/book.svg'
import { ReactComponent as ChartBoxIcon } from './icons/chart-box.svg'
import { ReactComponent as CheckBoxIcon } from './icons/check-box.svg'
import { ReactComponent as LoadingIcon } from './icons/loading.svg'
import { ReactComponent as StartIcon } from './icons/star.svg'
import { ReactComponent as TargetIcon } from './icons/target.svg'
import { ReactComponent as TextBoxIcon } from './icons/text-box.svg'
import { ReactComponent as UserPlusIcon } from './icons/user-plus.svg'

export const ITEMS = [
  {
    id: StudyGuideIconEnum.Book,
    title: 'Icon - Book',
    icon: <BookIcon />,
  },
  {
    id: StudyGuideIconEnum.Light,
    title: 'Icon - Light',
    icon: <LoadingIcon />,
  },
  {
    id: StudyGuideIconEnum.Checkmark,
    title: 'Icon - Checkmark',
    icon: <CheckBoxIcon />,
  },
  {
    id: StudyGuideIconEnum.Person,
    title: 'Icon - Person',
    icon: <UserPlusIcon />,
  },
  {
    id: StudyGuideIconEnum.Stats,
    title: 'Icon - Stats',
    icon: <ChartBoxIcon />,
  },
  {
    id: StudyGuideIconEnum.Text,
    title: 'Icon - Text',
    icon: <TextBoxIcon />,
  },
  {
    id: StudyGuideIconEnum.Anki,
    title: 'Icon - Anki',
    icon: <StartIcon />,
  },
  {
    id: StudyGuideIconEnum.Target,
    title: 'Icon - Target',
    icon: <TargetIcon />,
  },
]

type Item = (typeof ITEMS)[0]

export const IconBlock = () => {
  const { platform } = useParams()

  const color = platform === PlatformSlug.CARSBooster ? colors.accent : colors.perceptualAbility

  const renderOption = (item: Item) => (
    <div css={classes.optionWrapper}>
      <div css={classes.iconWrapper(color)}>{item.icon}</div>
      {item.title}
    </div>
  )

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Other Details Outside Article
      </Typography>

      <div css={classes.hr} />

      <SelectField<Item>
        name="icon"
        items={ITEMS}
        renderItem={renderOption}
        label="Icon for Study Guide Page in Classroom"
        fullWidth
        validate={validateRequired}
      />
    </div>
  )
}
